export default {
  common: {
    email: 'อีเมล',
    phone: 'โทรศัพท์',
    phoneNumber: 'หมายเลขโทรศัพท์',
    countrySelect: 'เลือกประเทศ',
    countryUnmodifiedNote: 'ไม่สามารถแก้ไขประเทศได้หลังจากลงทะเบียน',
    next: 'ถัดไป',
    back: 'ย้อนกลับ',
    attention: 'หมายเหตุ',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    modify: 'แก้ไข',
    ignore: 'เพิกเฉย',
    firstName: 'ชื่อ',
    middleName: 'ชื่อกลาง',
    lastName: 'นามสกุล',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    birthday: 'วันเกิด',
    graphicCode: 'รหัสกราฟิก',
    emailCode: 'รหัสยืนยันอีเมล',
    smsCode: 'รหัส SMS',
    smsVerificationCode: 'รหัสยืนยัน SMS',
    bind: 'ผูกบัญชี',
    send: 'ส่ง',
    resend: 'ส่งอีกครั้ง',
    address: 'ที่อยู่',
    done: 'เสร็จเรียบร้อย',
    systemMessage: 'ข้อความระบบ',
    setting: 'การตั้งค่า',
    submit: 'ส่ง',
    language: 'ภาษา',
    edit: 'แก้ไข',
    delete: 'ลบ'
  },
  account: {
    account: 'บัญชี',
    nickname: 'ชื่อเล่น',
    id: 'บัตรประจำตัวประชาชน',
    basicInfo: 'ระดับพื้นฐาน',
    placeholder: 'กรุณาเข้าสู่ระบบ',
    completed: 'อิ่มแล้ว',
    semiInfo: 'กึ่งตรวจสอบแล้ว',
    fullyInfo: 'ได้รับการตรวจสอบครบถ้วนแล้ว',
    basicTab: 'พื้นฐาน',
    advancedTab: 'ขั้นสูง',
    linkedAccount: 'บัญชีเกษียณอายุที่เชื่อมโยง',
    accountSecurity: 'บัญชี MetWallet และความปลอดภัย',
    logout: 'ออกจากระบบ',
    semiToast: 'กรุณากรอกการยืนยันระดับพื้นฐานให้เสร็จเรียบร้อย',
    fullyToast: 'กรุณากรอกการยืนยันระดับพื้นฐานและกึ่งสมบูรณ์ให้เสร็จเรียบร้อย',
    quickLoginTitle: 'การเข้าสู่ระบบด่วน',
    cancelQuickLogin: 'คุณแน่ใจหรือไม่ว่าต้องการปิดใช้งานการเข้าสู่ระบบด่วน?'
  },
  accountSecurity: {
    title: 'บัญชีและความปลอดภัย',
    payPwd: 'รหัสผ่านสำหรับการชำระเงิน',
    loginPwd: 'รหัสผ่านสำหรับเข้าสู่ระบบ',
    changeEmail: 'เปลี่ยนอีเมล',
    changePhone: 'เปลี่ยนหมายเลขโทรศัพท์',
    changePayPwd: 'เปลี่ยนรหัสผ่านสำหรับการชำระเงิน',
    changeLoginPwd: 'เปลี่ยนรหัสผ่านสำหรับเข้าสู่ระบบ',
    bindEmail: 'ผูกอีเมล',
    bindEmailNote: 'ผ่านการยืนยันอีเมลเพื่อผูกบัญชี',
    bindEmailPlaceholder: 'ป้อนอีเมลที่คุณต้องการผูกบัญชี',
    smsBindNote: 'ยืนยันผ่าน SMS เพื่อผูกมัด',
    bindPhone: 'ผูกหมายเลขโทรศัพท์',
    smsAuthentication: 'การยืนยันทาง SMS',
    emailAuthentication: 'การยืนยันทางอีเมล์',
    phoneVerificationNote: 'ผ่านการตรวจสอบหมายเลขโทรศัพท์ปัจจุบันก่อน',
    bindPhonePlaceholder: 'ป้อนหมายเลขโทรศัพท์ที่คุณต้องการผูกมัด',
    verificationWrongToast: 'โปรดตรวจสอบรหัสยืนยันของคุณ',
    phoneNumberEmptyToast: 'โปรดกรอกหมายเลขโทรศัพท์',
    verificationCodeEmptyToast: 'โปรดกรอกรหัส',
    wrongCodeToast: 'รหัสผิด',
    changeNote: 'โปรดยืนยันเพื่อเปลี่ยนแปลง',
    newEmailVerification: 'ยืนยันอีเมลใหม่',
    newEmailPlaceholder: 'ป้อนอีเมลใหม่ของคุณ',
    change: 'เปลี่ยน',
    emailLowercaseToast: 'อีเมลควรเป็นตัวอักษรพิมพ์เล็ก',
    newEmailEmptyToast: 'กรุณากรอกอีเมลใหม่',
    changeSuccessToast: 'เปลี่ยนเรียบร้อยแล้ว',
    phonePlaceholder: 'ป้อนหมายเลขโทรศัพท์',
    currentEmail: 'อีเมลปัจจุบัน',
    passCurrentEmailVerificationFirst: 'ผ่านการยืนยันอีเมลปัจจุบันก่อน',
    currentEmailVerification: 'การยืนยันอีเมลปัจจุบัน',
    smsVerification: 'การยืนยันทาง SMS',
    currentPhoneNumber: 'หมายเลขโทรศัพท์ปัจจุบัน',
    currentPhoneVerification: 'การยืนยันโทรศัพท์ปัจจุบัน',
    currentEmailAddress: 'ที่อยู่อีเมลปัจจุบัน',
    phoneVerification: 'ยืนยันทางโทรศัพท์',
    enterVerificationCode: 'ป้อนรหัสยืนยัน',
    newPhoneNumber: 'หมายเลขโทรศัพท์ใหม่',
    newEmail: ' อีเมล์ใหม่'
  },
  withdrawAccount: {
    selectAccountType: 'เลือกประเภทบัญชี',
    noBasicLevelVerificationDialog: 'กรุณากรอกการยืนยันระดับพื้นฐานให้เสร็จเรียบร้อยก่อนผูกบัญชีวิธีการถอนเงิน',
    bindNote: 'กรุณากรอกข้อมูลบัญชีที่ถูกต้อง มิฉะนั้นการถอนเงินของคุณจะได้รับผลกระทบ',
    bindBankAccount: 'ผูกบัญชีธนาคาร',
    bindMobileMoneyAccount: 'ผูกบัญชีเงินบนมือถือ',
    fieldEmptyToast: '{0} จำเป็นต้องกรอก',
    fieldLengthToast: '{0} ต้องมีอักขระอย่างน้อย {1} ตัว',
    bindBankRepeatToast: 'อย่าผูกบัญชีธนาคารเดียวกันซ้ำๆ!',
    accountName: 'ชื่อบัญชี',
    ifscCode: 'รหัส IFSC',
    accountEmptyToast: 'จำเป็นต้องกรอกบัญชี',
    accountNameEmptyToast: 'จำเป็นต้องกรอกชื่อบัญชี',
    phoneEmptyToast: 'จำเป็นต้องกรอกหมายเลขโทรศัพท์',
    emailEmptyToast: 'จำเป็นต้องกรอกอีเมล',
    ifscCodeEmptyToast: 'จำเป็นต้องกรอกรหัส IFSC',
    ifscCodeLengthToast: 'รหัส IFSC ต้องมี 11 หลัก',
    bindIMPSRepeatToast: 'อย่าผูกบัญชี IMPS เดียวกันซ้ำๆ!',
    bindNote2: 'โปรดกรอกที่อยู่ TRC-20 ที่ถูกต้องของคุณ ที่อยู่ผิดจะทำให้การชำระเงินสูญหาย ซึ่งเราจะไม่รับผิดชอบใดๆ',
    usdtAddress: 'ที่อยู่ USDT (TRC-20):',
    minimumLimit: 'การถอนขั้นต่ำต่อธุรกรรม: $10',
    usdtFee: 'ค่าใช้จ่าย: ขึ้นอยู่กับค่าธรรมเนียมจริง',
    registerGcash: 'หากคุณไม่มีบัญชี Gcash โปรดคลิกที่นี่เพื่อลงทะเบียน',
    registerEpay: 'หากคุณไม่มีบัญชี Epay โปรดคลิกที่นี่เพื่อลงทะเบียน',
    bindThirdPartyTitle: 'ผูกบัญชี {0}',
    wrongAccountToast: 'บัญชีผิด',
    accountFormatToast: 'รูปแบบบัญชีไม่ถูกต้อง',
    bindThirdPartyFailedToast: 'ผูกบัญชี {0} ไม่สำเร็จ',
    queryFailedToast: 'สอบถามล้มเหลว',
    editFailedToast: 'แก้ไขล้มเหลว',
    add: 'เพิ่ม',
    confirmEditDialog: 'คุณแน่ใจหรือไม่ว่าต้องการแก้ไขบัญชี {0}',
    payPwdRequireDialog: 'กรุณาตั้งรหัสผ่านการชำระเงิน 6 หลักก่อนเพิ่มบัญชี',
    unbindFailedToast: 'การยกเลิกการเชื่อมโยงล้มเหลว',
    cashOutSuccessNote: 'เวลาที่คาดว่าจะมาถึง：ภายใน 7 วันทำการ',
    requestSubmitted: 'ส่งคำขอถอนเงินแล้ว',
    amountLimitToast1: 'จำนวนเงินที่ถอนออกต้องมากกว่า $40.00 ดอลลาร์',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'จำนวนเงินที่ถอนออกต้องมากกว่า ${0}.00 ดอลลาร์',
    recommendAmountNote:
      'เคล็ดลับ: การสะสมจำนวนเงินถึง 0.00 ดอลลาร์ก่อนถอนเงินจะช่วยประหยัดค่าธรรมเนียมการดำเนินการได้อย่างมีประสิทธิภาพ',
    amountNotEnoughToast: 'จำนวนเงินที่ถอนออกไม่เพียงพอ',
    exceedingLimitToast1: 'จำนวนเงินที่ถอนออกในวันนี้ถึงขีดจำกัดสูงสุดแล้ว',
    exceedingLimitToast2:
      'จำนวนเงินที่ถอนออกในวันนี้ถึงขีดจำกัดสูงสุดแล้ว คุณจำเป็นต้องทำการรับรองขั้นสูงให้เสร็จสิ้นเพื่อเพิ่มขีดจำกัดหรือไม่',
    restrictedCountriesPayPalAccountToast:
      'อย่าใช้บัญชี PayPal ของประเทศที่ถูกจำกัด ซึ่งจะทำให้ Arripay ของคุณถูกบล็อก',
    withdrawMinimumToast: 'จำนวนเงินขั้นต่ำในการถอนต่อธุรกรรม: 40 ดอลลาร์',
    bankNotAvailableToast: 'ธนาคารนี้ไม่สามารถใช้งานได้อีกต่อไป กรุณาผูกบัญชีกับธนาคารอื่น',
    usdtAccountInvalidToast: 'ไม่สามารถถอนเงินออกจากบัญชี USDT ได้ กรุณาใช้บัญชีใหม่ในการถอนเงิน',
    noPayPwdToast: 'กรุณาตั้งรหัสผ่านการชำระเงิน 6 หลักก่อนถอนเงิน',
    editBankAccount: 'แก้ไขบัญชีธนาคาร',
    accountPlaceholder: 'ป้อนบัญชีของคุณ',
    trc20Placeholder: 'ป้อนที่อยู่ TRC-20',
    accountRepeatToast: 'เหมือนกับที่ใช้อยู่ในปัจจุบัน',
    unbindBankCardConfirmDialog: 'คุณแน่ใจหรือไม่ว่าจะยกเลิกการเชื่อมโยงบัตรธนาคาร {0}',
    unbindMobileMoneyAccountConfirmDialog: 'คุณแน่ใจหรือไม่ว่าจะยกเลิกการเชื่อมโยงบัญชีเงินบนมือถือ {0}',
    unbindAccountConfirmDialog: 'คุณแน่ใจหรือไม่ว่าจะยกเลิกการเชื่อมโยงบัญชี {0}',
    availableBalance: 'ยอดเงินคงเหลือ {0}',
    estimatedFee: 'ค่าธรรมเนียมโดยประมาณ',
    submitFailToast: 'ส่งไม่สำเร็จ',
    disabledMethodToast: 'ช่องทางนี้ไม่สามารถใช้งานได้ชั่วคราว',
    channelUnavailableTitle: 'ช่องทางไม่พร้อมใช้งาน',
    channelUnavailableNote: 'ช่องทางถอนเงินนี้ไม่พร้อมใช้งานชั่วคราว กรุณาลองวิธีอื่น',
    channelUnavailableOk: 'ตกลง',
    bankTransferUnavailableTitle: 'โอนเงินผ่านธนาคารไม่พร้อมใช้งาน',
    bankTransferUnavailableNote: 'บัญชีของคุณไม่สามารถใช้การโอนเงินผ่านธนาคารได้ในขณะนี้ กรุณาใช้ Epay เพื่อถอนเงิน',
    channelMaintenanceTitle: 'ช่องทางอยู่ระหว่างการบำรุงรักษา',
    channelMaintenanceNote: 'ช่องทางถอนเงินนี้อยู่ระหว่างการบำรุงรักษา กรุณาลองวิธีอื่น',
    bankInfoUpdateTitle: 'อัปเดตข้อมูลธนาคารของคุณ',
    bankInfoUpdateNote: 'เนื่องจากมีการปรับนโยบายของธนาคาร กรุณาอัปเดตข้อมูลธนาคารของคุณเพื่อดำเนินการต่อ',
    bindEpay: 'ผูก Epay',
    useEpay: 'ใช้ Epay',
    iMPSMaxLimitToast: 'จำนวนเงินถอนสูงสุดต่อธุรกรรมผ่านช่องทางนี้คือ 260 ดอลลาร์',
    linkedAccount: 'เพิ่มบัญชี',
    otherAccounts: 'สามารถเพิ่มบัญชีอื่นได้',
    withdrawTo: 'ถอนเงินได้',
    withdrawAmount: 'จำนวนเงินโอน',
    withdrawable: 'ถอนเงินได้',
    documentIdToast: 'หมายเลข ID สามารถมีตัวเลขได้เท่านั้น',
    noAvailableMethodNote: 'ไม่มีวิธีถอนเงินที่ใช้ได้',
    recommended: 'แนะนำ'
  },
  paymentCode: {
    changePayPwd: 'เปลี่ยนรหัสผ่านสำหรับการชำระเงิน',
    setPayPwd: 'ตั้งรหัสผ่านการชำระเงิน',
    setPayPwdNote: 'กรุณาตั้งรหัสผ่านการชำระเงิน 6 หลัก',
    reenterPayPwdNote: 'ป้อนอีกครั้ง',
    verificationNote: 'กรุณาผ่านการตรวจสอบเพื่อตั้งค่า',
    emailVerification: 'การยืนยันอีเมล',
    inconsistentPasswordToast: 'รหัสผ่านไม่สอดคล้องกัน',
    payPwdNote: 'โปรดป้อนรหัสผ่านการชำระเงิน',
    payPwdFormatToast: 'รหัสผ่านการชำระเงินเป็นตัวเลข 6 หลัก',
    payPwdWrongToast: 'รหัสผ่านการชำระเงินไม่ถูกต้อง',
    payPwdVerificationFailToast: 'ไม่สามารถยืนยันรหัสผ่านการชำระเงินได้!',
    successToast: 'ตั้งค่า \n เรียบร้อยแล้ว'
  },
  authorize: {
    requirement:
      '{0} ต้องได้รับข้อมูลต่อไปนี้จาก MetWallet ของคุณ{1} เพื่อให้บริการที่เกี่ยวข้องแก่คุณ ชื่อเล่น อวาตาร์ เพศ ฯลฯ',
    authorize: 'อนุญาต',
    switchAccount: 'เปลี่ยนบัญชี',
    goToMetWallet: 'ไปที่ MetWallet',
    notMatchTips: 'การดำเนินการล้มเหลว คุณสามารถเปิดใช้งานการเข้าสู่ระบบด่วนได้โดยใช้บัญชี MetWallet ที่ผูกไว้เท่านั้น'
  },
  basicLevel: {
    namePlaceholder: 'ไม่มีสัญลักษณ์หรือตัวเลข',
    verification: 'การยืนยัน',
    whatsAvailable: 'สิ่งที่มีให้',
    cashOut: 'ถอนเงิน',
    withdrawLimit: '$50 ต่อวัน',
    basicLevelNote: 'โปรดป้อนข้อมูลส่วนตัวจริงของคุณ ข้อมูลที่ผิดอาจทำให้การถอนเงินล้มเหลว',
    fieldEmptyToast: 'กรุณากรอกข้อมูลที่จำเป็นทั้งหมด',
    successToast: 'บันทึกแล้ว \n สำเร็จ',
    failToast: 'บันทึกไม่สำเร็จ',
    confirmDialog: 'ตรวจสอบให้แน่ใจว่าได้ป้อนข้อมูลส่วนตัวจริงของคุณ ข้อมูลที่ผิดอาจทำให้การถอนเงินล้มเหลว',
    birthdayFormatToast: 'รูปแบบช่องวันเกิดไม่ถูกต้อง',
    verificationCodeError: 'ข้อผิดพลาดรหัสยืนยัน',
    verificationCodeEmpty: 'รหัสยืนยันว่างเปล่า',
    noEmailCodeToast: 'กรุณารับรหัสยืนยันทางอีเมล์',
    checkDialogTitle: 'ตรวจสอบข้อมูลของคุณ',
    checkDialogContent: 'เพื่อการถอนเงินที่สำเร็จ โปรดตรวจสอบข้อมูลของคุณ ข้อมูลที่ผิดอาจทำให้การถอนเงินล้มเหลว',
    check: 'ตรวจสอบ'
  },
  semiVerified: {
    uploadPhotoId: 'อัปโหลดบัตรประจำตัวที่มีรูปถ่าย',
    photoId: 'บัตรประจำตัวที่มีรูปถ่าย',
    resubmit: 'ส่งใหม่',
    limit: '$5,000 ต่อวัน',
    uploading: 'กำลังอัปโหลด...',
    notUploadProofToast: 'กรุณาอัปโหลดหลักฐานบัตรประจำตัว'
  },
  fullyVerified: {
    frontOfId: 'ด้านหน้าบัตร',
    backOfId: 'ด้านหลังบัตร',
    uploadIdFront: 'อัปโหลดด้านหน้าบัตร',
    uploadIdBack: 'อัปโหลดด้านหลังบัตร',
    withdrawDailyHint: 'กรอกข้อมูลเพื่อถอน > {0} ต่อวัน',
    notUploadIdToast: 'กรุณาอัปโหลดด้านหน้าและด้านหลังบัตร',
    proofTitle: 'เอกสารหลักฐานถิ่นที่อยู่',
    acceptableProof: 'หลักฐานถิ่นที่อยู่ที่สามารถยอมรับได้ ได้แก่:',
    acceptableProof1: 'ใบแจ้งยอดบัญชีธนาคาร',
    acceptableProof2: 'ใบแจ้งค่าสาธารณูปโภค (ค่าไฟ ค่าน้ำ ค่าอินเทอร์เน็ต ฯลฯ)',
    acceptableProof3: 'เอกสารที่รัฐบาลออก (ใบแจ้งภาษี ใบรับรองถิ่นที่อยู่ ฯลฯ)',
    unacceptableProof: 'เราไม่สามารถยอมรับที่อยู่บนเอกสารประจำตัวที่คุณส่งมาเป็นหลักฐานถิ่นที่อยู่ที่ถูกต้องได้',
    limit: '10,000 ดอลลาร์ต่อวัน',
    notUploadToast: 'โปรดอัปโหลดเอกสารหลักฐานถิ่นที่อยู่',
    incorrectFormatToast: 'โปรดอัปโหลดรูปภาพ jpg/png/jpeg'
  },
  loginAndRegister: {
    pwd: 'รหัสผ่าน',
    lastLogin: 'เข้าสู่ระบบครั้งล่าสุด',
    moreOptions: 'ตัวเลือกเพิ่มเติม',
    agreeCheckboxContent: 'ยอมรับ {0} และ {1}',
    userAgreement: 'ข้อตกลงผู้ใช้',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    notAgreeToast: 'ยอมรับข้อตกลงผู้ใช้และนโยบายความเป็นส่วนตัว',
    forgotPassword: 'ลืมรหัสผ่าน',
    linkedMail: 'อีเมลที่เชื่อมโยง',
    verificationCode: 'รหัสยืนยัน',
    newPwd: 'รหัสผ่านใหม่',
    repeatPwd: 'ยืนยันรหัสผ่านอีกครั้ง',
    confirmPwd: 'ยืนยันรหัสผ่าน',
    noLinkedEmailToast: 'ไม่มีอีเมลที่เชื่อมโยงกับบัญชีของคุณ',
    unregisteredToast: 'ยังไม่ได้ลงทะเบียนหมายเลขนี้',
    pwdFormatToast: 'รูปแบบของรหัสผ่านไม่ถูกต้อง',
    resetSuccessToast: 'รีเซ็ต \n สำเร็จ',
    pwdNotMatchToast: 'รหัสผ่านไม่ตรงกันสองครั้ง',
    emailFormatToast: 'รูปแบบอีเมลไม่ถูกต้อง',
    phoneNumberFormatToast: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
    invalidAreaCodeToast: 'รหัสพื้นที่ไม่ถูกต้อง',
    login: 'เข้าสู่ระบบ',
    pwdLogin: 'เข้าสู่ระบบด้วยรหัสผ่าน',
    emailCodeLogin: 'เข้าสู่ระบบด้วยรหัสยืนยันอีเมล',
    smsLogin: 'เข้าสู่ระบบด้วย SMS',
    verifyEmail: 'ยืนยันอีเมล',
    verifyPhone: 'ยืนยันโทรศัพท์',
    accountDangerDialog:
      'บัญชีของคุณถูกตรวจพบว่ามีความเสี่ยง กรุณายืนยันบัญชีของคุณอีกครั้ง มิฉะนั้น บัญชีของคุณจะใช้งานต่อไม่ได้',
    sendEmailCodeDialog: 'เราได้ส่งรหัสยืนยันไปยังอีเมล {0} ของคุณแล้ว โปรดป้อนรหัสยืนยัน',
    sendSmsCodeDialog: 'เราได้ส่งรหัสยืนยันไปยังโทรศัพท์ {0} ของคุณแล้ว โปรดป้อนรหัสยืนยัน',
    graphicCodeEmptyToast: 'โปรดป้อนรหัสกราฟิก',
    countryUnselectToast: 'โปรดเลือกประเทศของคุณก่อน',
    unsupportedLoginTypeToast: 'ประเภทการเข้าสู่ระบบที่ไม่รองรับ',
    pwdWrongLimitOverDialog: 'มีการป้อนรหัสผ่านไม่ถูกต้อง 3 ครั้ง โปรดใช้รหัสยืนยันทาง SMS เพื่อเข้าสู่ระบบ',
    loginFailedToast: 'เข้าสู่ระบบไม่สำเร็จ',
    signIn: 'ลงชื่อเข้าใช้',
    pwdPlaceholder: 'ป้อนรหัสผ่าน',
    pwdNote: 'ป้อนตัวอักษร 8-16 ตัว (รวมตัวเลขและตัวอักษร)',
    reenterPwdPlaceholder: 'ป้อนรหัสผ่านอีกครั้ง',
    reenterPwdNote: 'กรุณาป้อนรหัสผ่านอีกครั้ง',
    createAccount: 'สร้างบัญชี',
    chooseCountryNote: 'กรุณาเลือกประเทศ',
    pwdInconsistentToast: 'ไม่เหมือนกับรหัสผ่านที่คุณป้อนก่อนหน้านี้',
    createSuccessToast: 'สร้าง \n สำเร็จ',
    registerFailToast: 'ลงทะเบียนล้มเหลว',
    userNotExistToast: 'ผู้ใช้ไม่มีอยู่',
    phoneIncorrectToast: 'โปรดตรวจสอบโทรศัพท์ของคุณ',
    userExistToast: 'ผู้ใช้มีอยู่แล้ว',
    countryCodeRepeatToast: 'กรุณาอย่าป้อนรหัสประเทศซ้ำ!',
    logoutDialog: 'คุณแน่ใจหรือไม่ว่าจะออกจากระบบ',
    pwdRequirement: 'รหัสผ่านต้องมีอย่างน้อย 8 ถึง 16 ตัวอักษรพร้อมตัวอักษรและตัวเลข',
    signup: 'ลงทะเบียน',
    registerSuccessToast: 'ลงทะเบียน \n เรียบร้อยแล้ว',
    oldPwdErrorToast: 'โปรดตรวจสอบรหัสผ่านเดิมของคุณ'
  },
  checkUserInfo: {
    title: 'ศูนย์การจัดการ',
    emptyInfoNote: 'ไม่มีข้อมูลสำหรับบัญชีปัจจุบัน โปรดตรวจสอบบัญชี MetWallet ที่คุณต้องการยืนยัน',
    infoNote: 'นี่คือข้อมูลยืนยันของคุณ',
    lastSuccessWithdrawal: 'การถอนเงินครั้งล่าสุดที่ประสบความสำเร็จ',
    copyBtn: 'คัดลอก',
    successToast: 'คัดลอกสำเร็จ!',
    failToast: 'คัดลอกล้มเหลว!'
  },
  country: {
    title: 'เลือกภูมิภาค',
    popular: 'ยอดนิยม'
  },
  documentDetails: {
    title: 'รายละเอียดเอกสาร',
    contract: 'สัญญา',
    goToSign: 'ไปที่ลงนาม',
    download: 'ดาวน์โหลด',
    upload: 'อัปโหลด',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., เอกสารเท่านั้น',
    contentEmptyToast: 'กรุณาป้อนเนื้อหา',
    placeOfBirth: 'สถานที่เกิด',
    occupation: 'อาชีพ',
    fileForm: '(แบบฟอร์มไฟล์)',
    proofOfAddress: 'หลักฐานที่อยู่เป็นภาษาอังกฤษ',
    residenceDoc: 'เอกสารที่อยู่อาศัย',
    textForm: '(แบบฟอร์มข้อความ)',
    contractAgent: 'ตัวแทนสัญญา',
    contractPayslip: 'สลิปเงินเดือนสัญญา',
    uncompletedToast: 'กรุณากรอกข้อมูลเพื่อส่ง',
    successToast: 'ส่งสำเร็จ',
    undefinedFileTypeToast: 'ประเภทการอัปโหลดไฟล์ไม่ระบุ',
    uploadFailToast: 'การอัปโหลดล้มเหลว'
  },
  filters: {
    amount: 'จำนวน',
    filter: 'ตัวกรอง',
    time: 'เวลา',
    reset: 'รีเซ็ต',
    timePickerTitle: 'เลือกเวลา {0}',
    start: 'เริ่มต้น',
    end: 'สิ้นสุด',
    maximum: 'สูงสุด',
    minimum: 'ขั้นต่ำ'
  },
  home: {
    balance: 'ยอดคงเหลือ',
    transactions: 'ธุรกรรม',
    availableBalance: 'ยอดคงเหลือที่ใช้ได้',
    noWithdrawalMethodToast: 'จำเป็นต้องมีวิธีการถอนเงินอย่างน้อยหนึ่งวิธี',
    linkAccount: 'เชื่อมโยงบัญชี',
    all: 'ทั้งหมด',
    cashIn: 'ถอนเงินเข้า',
    loading: 'กำลังโหลด...',
    noMore: 'ไม่มีธุรกรรมอีกต่อไป',
    reload: 'โหลดไม่สำเร็จ คลิกเพื่อโหลดซ้ำ',
    receivedFrom: 'รับจาก',
    transferredTo: 'โอนไปยัง',
    fee: 'ค่าธรรมเนียมการโอนไปยัง',
    myEmail: 'อีเมลของฉัน',
    myPhone: 'โทรศัพท์ของฉัน',
    invalidBasicLevelDialog:
      'เนื่องจากมีสัญลักษณ์ ช่องว่าง หรือตัวเลขในช่องชื่อของคุณ จึงไม่สามารถถอนเงินจากบัญชีได้ กรุณากรอกข้อมูลพื้นฐานอีกครั้ง (โปรดแน่ใจว่าชื่อไม่มีสัญลักษณ์ ช่องว่าง หรือตัวเลข และหากคุณไม่มีนามสกุลหรือชื่อกลาง ให้เว้นว่างไว้)',
    lackLastNameDialog: 'ไม่ได้กรอกนามสกุลของคุณ ซึ่งจะขัดขวางการถอนเงินของคุณ',
    fillIn: 'กรอก',
    viewDetails: 'ดูรายละเอียด',
    docReviewingDialogTitle: 'กรุณารอสักครู่เพื่อรอเอกสารผ่าน',
    docReviewingDialogContent:
      'คุณได้ส่งเอกสารแล้ว แต่คุณไม่สามารถใช้ MetWallet ได้ก่อนที่เอกสารของคุณจะผ่าน<br>เจ้าหน้าที่จะดำเนินการในเร็วๆ นี้ โปรดรอสักครู่',
    docPassedDialog: 'เอกสารที่คุณส่งผ่านผ่านแล้ว <br>ขณะนี้คุณสามารถใช้ MetWallet ได้ตามปกติ',
    docUnqualifiedDialog: 'เอกสารที่คุณส่งผ่านไม่มีคุณสมบัติ <br>กรุณาส่งเอกสารที่มีคุณสมบัติ',
    goToSubmit: 'ไปส่ง',
    uncompletedDialog: 'คุณต้องกรอกข้อมูลให้ครบถ้วนจึงจะใช้ MetWallet ได้ตามปกติ',
    useMetWalletNormallyAfterPassed: 'คุณสามารถใช้ MetWallet ได้ตามปกติหลังจากผ่านเอกสารแล้ว',
    requireSemiVerifiedDialog:
      '{0} สำหรับข้อกำหนดของธนาคาร คุณต้องทำส่วนที่ผ่านการตรวจสอบบางส่วนให้เสร็จภายใน 48 ชั่วโมงจึงจะถอนเงินได้สำเร็จ',
    goToVerify: 'ไปตรวจสอบ',
    emailInvalidDialog:
      '{0} ที่อยู่อีเมลของคุณเหมือนกับของคนอื่น เพื่อความปลอดภัยในความเป็นส่วนตัว โปรดป้อนที่อยู่อีเมลของคุณเองโดยเร็วที่สุด',
    later: 'ในภายหลัง',
    transferRequireSemiVerifiedDialog: 'กรุณาทำการยืนยันกึ่งยืนยันให้เสร็จสิ้นก่อนโอน',
    modifyBtnText: 'แก้ไขข้อมูลของฉัน',
    unmodifiedTitle: 'ไม่สามารถแก้ไข',
    unmodifiedContent: 'คุณมีคำสั่งถอนเงินที่กำลังดำเนินการ ข้อมูลไม่สามารถแก้ไขได้ในขณะนี้'
  },
  signing: {
    signature: 'ลายเซ็น',
    date: 'วันที่',
    employeeName: 'ชื่อพนักงาน',
    designation: 'ตำแหน่ง',
    month: 'เดือน',
    year: 'ปี',
    earnings: 'รายได้',
    deductions: 'การหักเงิน',
    basic: 'พื้นฐานและ DA(USD)',
    totalAddition: 'ยอดรวม',
    totalDeduction: 'ยอดหักเงินทั้งหมด',
    salary: 'เงินเดือนสุทธิ',
    refNo: 'หมายเลขอ้างอิง',
    paymentTransferDate: 'วันที่โอนเงิน',
    nameOfBank: 'ชื่อธนาคาร',
    signatureOfEmployee: 'ลายเซ็นของพนักงาน',
    director: 'ผู้อำนวยการ',
    signNote: 'โปรดลงชื่อ',
    preview: 'ดูตัวอย่าง',
    clear: 'ล้างข้อมูล',
    save: 'บันทึก',
    noSignatureToast: 'คุณไม่สามารถบันทึกได้หากไม่มีลายเซ็น',
    fieldEmptyToast: 'โปรดกรอกข้อมูลทั้งหมด'
  },
  transactionDetail: {
    title: 'รายละเอียดธุรกรรม',
    status: 'สถานะ',
    pending: 'รอดำเนินการ',
    completed: 'เสร็จสิ้น',
    success: 'สำเร็จ',
    failed: 'ล้มเหลว',
    cancelled: 'ยกเลิก',
    onHold: 'ระงับ',
    reason: 'เหตุผลสถานะ',
    description: 'คำอธิบาย',
    creationDate: 'วันที่สร้าง',
    lastStatusDate: 'วันที่สถานะล่าสุด',
    requestedAmount: 'จำนวนเงินที่ร้องขอ',
    receiveAmount: 'จำนวนเงินที่ได้รับ',
    transferAmount: 'จำนวนเงินที่โอน',
    amountToPay: 'จำนวนเงินที่ต้องชำระ',
    transferFee: 'ค่าธรรมเนียมการโอน',
    processingFee: 'ค่าธรรมเนียมการดำเนินการ',
    method: 'วิธีการ',
    country: 'ประเทศ',
    name: 'ชื่อ',
    bankPendingText: 'อยู่ภายใต้การตรวจสอบขั้นสุดท้ายของธนาคาร',
    pendingText: 'อยู่ภายใต้การตรวจสอบ {0}',
    chametSalary: 'เงินเดือนชาเม็ต',
    userSalary: 'เงินเดือนผู้ใช้',
    comm: 'คอมม์',
    gemgalaSalary: 'เงินเดือน Gemgala'
  },
  transfer: {
    title: 'ไปยังบัญชี MetWallet',
    noPayPwdDialog: 'โปรดตั้งรหัสผ่านการชำระเงิน 6 หลักก่อนโอนเงิน',
    records: 'บันทึก',
    cashInOut: 'ฝากเงินเข้า {0} ถอนเงินออก {1}',
    transfer: 'โอน',
    fee: 'ค่าธรรมเนียม',
    remark: 'หมายเหตุ',
    transferTo: 'โอนไปยัง {0}',
    remarkPlaceholder: 'เพิ่มหมายเหตุการโอน (น้อยกว่า 100 ตัวอักษร)',
    firstNameNote: 'กรุณากรอกชื่อจริงของผู้รับเงิน',
    sendingAmount: 'จำนวนเงินที่ส่ง',
    receivingAmount: 'จำนวนเงินที่รับเงิน',
    transferNow: 'โอนทันที',
    noBalanceToast: 'จำนวนเงินที่โอนต้องมากกว่าจำนวนเงินคงเหลือ',
    amountTooLittleToast: 'จำนวนเงินที่โอนต้องไม่น้อยกว่า 10 ดอลลาร์'
  },
  bankData: {
    beneficiaryName: 'ชื่อผู้รับผลประโยชน์',
    beneficiaryNamePlaceholder: 'ป้อนชื่อ',
    beneficiaryLastname: 'นามสกุลผู้รับผลประโยชน์',
    beneficiaryLastnamePlaceholder: 'ป้อนนามสกุล',
    bankCode: 'รหัสธนาคาร',
    bankCodePlaceholder: 'เลือกรหัสธนาคาร',
    bankIFSCCode: 'รหัส IFSC ของธนาคาร',
    bankIFSCCodePlaceholder: 'ป้อนรหัส IFSC ของธนาคาร',
    bankAccount: 'บัญชีธนาคาร',
    bankAccountPlaceholder: 'ป้อนบัญชีธนาคาร',
    email: 'อีเมล',
    emailPlaceholder: 'ป้อนอีเมล',
    phoneNumber: 'หมายเลขโทรศัพท์',
    phoneNumberPlaceholder: 'ป้อนหมายเลขโทรศัพท์',
    address: 'ที่อยู่',
    addressPlaceholder: 'ป้อนที่อยู่',
    city: 'เมือง',
    cityPlaceholder: 'ป้อนเมือง',
    state: 'รัฐ',
    statePlaceholder: 'ป้อนรัฐ',
    postCode: 'รหัสไปรษณีย์',
    postCodePlaceholder: 'ป้อนรหัสไปรษณีย์',
    documentId: 'รหัสเอกสาร',
    documentIdPlaceholder: 'ป้อนรหัสเอกสาร',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'ประเภทเอกสาร',
    documentTypePlaceholder: 'เลือกประเภทเอกสาร',
    accountType: 'ประเภทบัญชี',
    accountTypePlaceholder: 'เลือกประเภทบัญชี',
    cpfcnpjPlaceholder: 'ป้อน CPFCNPJ',
    bankBranch: 'สาขาธนาคาร',
    bankBranchPlaceholder: 'ป้อนสาขาธนาคาร',
    ribOfBankAccount: 'RIB ของบัญชีธนาคาร',
    bankName: 'ชื่อธนาคาร',
    bankNamePlaceholder: 'ป้อนชื่อธนาคาร',
    bicCode: 'รหัส BIC',
    bicCodePlaceholder: 'ป้อนรหัส BIC',
    ibanPlaceholder: 'ป้อน IBAN',
    bankSwift: 'รหัส SWIFT ของธนาคาร',
    bankSwiftPlaceholder: 'ป้อนรหัส SWIFT ของธนาคาร',
    name: 'ชื่อ',
    documentCountry: 'ประเทศของเอกสาร',
    documentCountryPlaceholder: 'เลือกประเทศของเอกสาร',
    issueDate: 'วันที่ออกเอกสาร',
    issueDatePlaceholder: 'เลือกวันที่ออกเอกสาร',
    expireDate: 'วันหมดอายุเอกสาร',
    expireDatePlaceholder: 'เลือกวันหมดอายุ',
    bankBranchName: 'ชื่อสาขาธนาคาร',
    bankBranchNamePlaceholder: 'ป้อนชื่อสาขา',
    branchPlaceholder: 'ป้อนสาขา',
    gender: 'เพศ',
    genderPlaceholder: 'เลือก เพศ',
    birthday: 'วันเกิด',
    birthdayPlaceholder: 'เลือกวันเกิด',
    phone: 'โทรศัพท์',
    bankAddress: 'ที่อยู่ธนาคาร',
    bankAddressPlaceholder: 'ป้อนที่อยู่ธนาคาร',
    bankAccountName: 'ชื่อบัญชีธนาคาร',
    bankAccountNamePlaceholder: 'ป้อนชื่อบัญชีธนาคาร',
    province: 'จังหวัด',
    provincePlaceholder: 'ป้อนจังหวัด',
    postalCode: 'รหัสไปรษณีย์',
    postalCodePlaceholder: 'ป้อนรหัสไปรษณีย์',
    savingsAccount: 'บัญชีออมทรัพย์',
    abaRoutingNumber: 'หมายเลขกำหนดเส้นทาง ABA',
    englandBankAccount: 'บัญชีธนาคารอังกฤษ',
    bankBranch2: 'สาขาธนาคาร',
    bankBranch2Placeholder: 'เฉพาะในกรณีที่ธนาคารเป็นซานทานเดอร์',
    paternalName: 'ชื่อบิดา',
    paternalNamePlaceholder: 'ป้อนชื่อบิดา',
    passportIdNumber: 'หมายเลขประจำตัวหนังสือเดินทาง',
    bankNamePlaceholder2: 'เลือกชื่อธนาคาร',
    areaCode: 'รหัสพื้นที่',
    phoneNumberNoAreaCode: 'หมายเลขโทรศัพท์ (ไม่มีรหัสพื้นที่)',
    idType: 'ประเภท ID',
    idNo: 'หมายเลข ID',
    idIssueDate: 'วันที่ออก ID',
    idExpireDate: 'วันหมดอายุ ID',
    ibanStyleToast: "กรุณาใส่เนื้อหาที่เริ่มต้นด้วย 'SA' และมีความยาว 24 ตัวอักษร"
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'คุณสามารถโอนไปยังผู้ขายเพชรเท่านั้น',
    search: 'ค้นหา',
    history: 'ผู้ใช้ที่ถูกโอน',
    confirm_content: 'คุณแน่ใจหรือไม่ว่าจะโอน {0} ไปยัง {1}',
    success_content: '{0} ถูกโอนไปยัง {1} แล้ว',
    purchase: 'ซื้อ',
    purchase_success: 'คุณได้ซื้อ {0} สำเร็จแล้ว',
    insufficient_balance: 'ยอดคงเหลือไม่เพียงพอ',
    purchase_diamond: 'ซื้อเพชร',
    transfer_limit_2: 'จำนวนเงินโอนควรอยู่ระหว่าง $10 ถึง $30,000',
    no_data: 'ไม่มีข้อมูล',
    invalid_number: 'กรุณาใส่ตัวเลขที่ถูกต้อง',
    under_limit: 'จำนวนเงินโอนควรไม่น้อยกว่า $10',
    over_limit: 'จำนวนเงินโอนควรน้อยกว่า $30,000'
  },
  redesign: {
    emailPlaceholder: 'ป้อนที่อยู่อีเมล',
    retrievePwd: 'รับรหัสผ่านใหม่',
    resetPwd: 'รีเซ็ตรหัสผ่าน',
    newPwdPlaceholder: 'ป้อนรหัสผ่านใหม่',
    reenterNewPwdPlaceholder: 'ป้อนรหัสผ่านใหม่อีกครั้ง',
    reenterPayPwdPlaceholder: 'โปรดป้อนรหัสผ่านการชำระเงินอีกครั้ง',
    sendToPhone: 'รหัสยืนยันถูกส่งไปยังโทรศัพท์ของคุณแล้ว',
    sendToWhatsapp: 'รหัสยืนยันถูกส่งไปยัง WhatsApp ของคุณแล้ว',
    sendToEmail: 'รหัสยืนยันถูกส่งไปยังอีเมลของคุณแล้ว',
    invalidCode: 'รหัสไม่ถูกต้อง',
    userId: 'รหัสผู้ใช้',
    other: 'อื่นๆ',
    transactionRecord: 'บันทึกธุรกรรม',
    bankCardInfo: 'บัญชีบัตรธนาคาร',
    withdrawInfo: 'บัญชีถอนเงิน',
    toFillIn: 'ต้องกรอก',
    walletInfo: 'ข้อมูลบัญชีกระเป๋าเงิน',
    toComplete: 'ต้องกรอก',
    verifyGuide: 'กรอกข้อมูลบัญชีกระเป๋าเงินเพื่อรับคุณสมบัติการถอนเงินเพิ่มเติม',
    verifyNote: 'กรอกข้อมูลต่อไปนี้เพื่อรับคุณสมบัติการถอนเงินรายวันของ {0}',
    verifyCompletedNote: 'กรอกข้อมูลเพื่อรับคุณสมบัติการถอนเงินรายวันของ {0}',
    continueBtnText: 'กรอกข้อมูลต่อ',
    submitInfo: 'ส่งข้อมูล',
    transferAmount: 'จำนวนเงินโอน',
    newEmailVerify: 'การยืนยันอีเมลใหม่',
    verifyCodePlaceholder: 'ป้อนรหัสยืนยัน',
    emailIncorrectToast: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    newPhone: 'หมายเลขโทรศัพท์ใหม่',
    accountAdded: 'เพิ่มข้อมูลบัญชีแล้ว',
    accountToAdd: 'สามารถเพิ่มบัญชีอื่นได้',
    edit: 'แก้ไข',
    enterPayPwd: 'ป้อนรหัสผ่านการชำระเงิน',
    deleteBtnText: 'ลบ',
    transferTo: 'โอนเข้า',
    withdrawable: 'ถอนเงินได้',
    goSet: 'ไปตั้งค่า',
    goModify: 'ไปแก้ไข'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/th.js